import React from "react";
import {CustomerFluidSubPageLayout} from "../../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CodPastPeriodsPage} from "../CodPastPeriodsPage";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

export const MerchantCODPastPeriodsPage = () => {
    return (
        <CustomerFluidSubPageLayout pageTitle="Kapıda Ödemeler - Geçmiş Dönemler">
            <CustomerMenuHeader />
            <div style={{width: "100%"}}>
                <CodPastPeriodsPage isFromCustomerTheme={true} />
            </div>
        </CustomerFluidSubPageLayout>
    );
};
